import { useGetPlatformAnalyticsApiV1Suspense } from "@/api/__generated__/api.schema";
import { useWorkspaceId } from "@/hooks/auth/use-workspace";
import { PlatformFlag, getPlatformName } from "@/routes/custom-music/dsp-analytics/components/graphics/platform-flag";
import { RevenueBreakdownTable } from "@/routes/custom-music/dsp-analytics/components/graphics/revenue-breakdown-table";
import { RevenueChart } from "@/routes/custom-music/dsp-analytics/components/graphics/revenue-chart";
import { useAnalyticsMonth } from "@/routes/custom-music/dsp-analytics/context/dsp-analytics-context";
import { getPreviousMonthRange } from "@/utils/date";
import { formatMonthString } from "@/utils/time";
import { Typography } from "@backpac/monica";
import { useState } from "react";

export const PlatformAnalytics = () => {
  const { selectedMonthRange } = useAnalyticsMonth();
  const workspaceId = useWorkspaceId();
  const {
    data: {
      data: { items: platformAnalytics },
    },
  } = useGetPlatformAnalyticsApiV1Suspense(workspaceId, {
    from: formatMonthString(selectedMonthRange[0]),
    to: formatMonthString(selectedMonthRange[1]),
  });
  // previous revenue with the same length as the current revenue
  const {
    data: {
      data: { items: previousPlatformAnalytics },
    },
  } = useGetPlatformAnalyticsApiV1Suspense(workspaceId, {
    from: formatMonthString(getPreviousMonthRange(selectedMonthRange)[0]),
    to: formatMonthString(getPreviousMonthRange(selectedMonthRange)[1]),
  });

  const [selectedIds, setSelectedIds] = useState<string[]>(() =>
    platformAnalytics.slice(0, 5).map((item) => getPlatformName(item.name)),
  );

  return (
    <div className="flex flex-col gap-6">
      <RevenueChart
        analytics={platformAnalytics.map((p) => ({
          ...p,
          name: getPlatformName(p.name),
        }))}
        previousAnalytics={previousPlatformAnalytics}
        selectedIds={selectedIds}
      />
      <RevenueBreakdownTable
        title="Platform"
        analytics={platformAnalytics}
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
        additionalColumns={[
          {
            label: "Platform",
            render: (item) => <PlatformFlag platform={item.name} />,
            position: "start",
          },
          {
            label: "# of Tracks",
            render: (item) => (
              <Typography size="xs" color="textPrimary">
                {item.trackCount}
              </Typography>
            ),
            position: "end",
          },
        ]}
      />
    </div>
  );
};
